import { render, staticRenderFns } from "./AddClient.vue?vue&type=template&id=35be9e17&scoped=true"
import script from "./AddClient.vue?vue&type=script&lang=js"
export * from "./AddClient.vue?vue&type=script&lang=js"
import style0 from "./AddClient.vue?vue&type=style&index=0&id=35be9e17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35be9e17",
  null
  
)

export default component.exports